import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import styles from './Page.module.css';

const TermsOfUse = (): JSX.Element => (
  <>
    <Box component="section" className={styles.section} style={{ paddingTop: '3rem' }}>
      <Typography variant="h1">Terms Of Use</Typography>
      <Typography variant="body2" className={styles.text} style={{ fontStyle: 'italic' }}>
        Last updated May 19, 2025
      </Typography>
    </Box>
    <Box component="section" className={styles.section} style={{ paddingTop: '3rem' }}>
      <Typography variant="h2" className={styles.title}>
        Pizza Hut Terms Of Use
      </Typography>
      <Typography variant="body1" className={styles.text}>
        These Terms of Use (&quot;Terms&quot;) together with any documents incorporated by reference herein, govern,
        among other things, your use of the Pizza Hut, LLC (&ldquo;Pizza Hut&rdquo;) websites, any applicable mobile
        application offered by us, and any other site on which these Terms appear, and any related features or services,
        including, without limitation, the purchase and sale of products and services, whether as a guest or a
        registered user (“Services”). By accessing or otherwise using Services, or otherwise agreeing to these Terms,
        you agree to be bound by them. Pizza Hut may revise the Terms, information, services and the resources from time
        to time, and Pizza Hut we reserves the right to make such changes without obligation to notify past, current or
        prospective visitors. Your continued access or use of the Services after changes have been made, among other
        things, constitutes your acceptance of any new or amended Terms. Throughout the Services and these Terms, the
        terms &quot;we&quot; and &quot;our&quot; refer to Pizza Hut and &quot;us&quot; refers to you and Pizza Hut.
        Pizza Hut offers this Site, including all information, tools and services available from the Services, to you,
        the user, conditioned upon your acceptance of these Terms.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        In no event shall Pizza Hut be liable for any indirect, special, incidental or consequential damages arising out
        of any use of the information contained herein.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        THESE TERMS CONTAIN DISPUTE RESOLUTION PROVISIONS THAT INCLUDE AN AGREEMENT TO MANDATORY INDIVIDUAL ARBITRATION
        AND A CLASS ACTION AND JURY TRIAL WAIVER THAT AFFECT YOUR RIGHTS. THE CLASS ACTION WAIVER MEANS YOU AGREE TO
        PROCEED WITH ANY CLAIM OR DISPUTE INDIVIDUALLY AND NOT AS PART OF ANY CLASS, COLLECTIVE, OR REPRESENTATIVE
        ACTION. YOU AGREE TO BE BOUND BY THESE DISPUTE RESOLUTION PROVISIONS. IN ARBITRATION, THERE IS NO JUDGE OR JURY
        AND THERE IS LESS DISCOVERY AND APPELLATE REVIEW THAN IN COURT. PLEASE REVIEW THESE PROVISIONS CAREFULLY.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        These Terms constitute a legally binding agreement and the entire agreement between you and Pizza Hut regarding
        accessing or using the Services and the features therein.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        By installing, accessing, or using the Services, or clicking “Accept,” “Agree,” or “Place Order” when this
        option is made available to you, you: (i) acknowledge that you have read and understood these Terms; and (ii)
        accept these Terms and agree that you are legally bound by these Terms and any other terms or policies
        incorporated by reference herein.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        NO WARRANTY / LIMITATION ON LIABILITY
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Pizza Hut strives to ensure that the information contained in the Services is accurate and reliable. However,
        Pizza Hut, the internet, and the Services are not infallible, and errors may sometimes occur. Therefore, to the
        fullest extent permissible pursuant to applicable law, Pizza Hut makes no representations about the reliability
        of the features of the Services, the Pizza Hut Content (defined below) Submitted Content (defined below) or any
        other Services feature. You acknowledge that any reliance on such material and/or systems will be at your own
        risk. Pizza Hut is not responsible for the information, data, text or other materials that may appear in
        Submitted Content or may otherwise be submitted by users. Opinions expressed in Submitted Content do not reflect
        the opinions of Pizza Hut, and Pizza Hut does not endorse and has no control over Submitted Content. Submitted
        Content is not necessarily reviewed by Pizza Hut prior to posting and Pizza Hut has no obligation to review,
        monitor, delete, or edit Submitted Content. However, you acknowledge and agree that Pizza Hut has the right to
        review Submitted Content at any time in its sole discretion, for any reason, or no reason, with or without
        notice. Pizza Hut makes no warranties, express or implied, as to the Submitted Content or to the accuracy and
        reliability of the Submitted Content. Pizza Hut makes no representations regarding the amount of time that any
        Pizza Hut Content or Submitted Content will be preserved.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Pizza Hut disclaims any warranty of any kind, whether express or implied, as to any matter whatsoever relating
        to the Services, including without limitation the merchantability or fitness for any particular purpose. Pizza
        Hut is not liable or responsible for any damages or injuries caused by use of the Services (such as viruses,
        omissions or misstatements). THE SERVICES ARE PROVIDED ON AN &quot;AS IS, AS AVAILABLE&quot; BASIS. NO
        WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THOSE OF MERCHANTABILITY OR FITNESS FOR A
        PARTICULAR PURPOSE, ARE MADE WITH RESPECT TO THE SERVICES OR ANY INFORMATION OR SOFTWARE USED IN CONNECTION
        THERE WITH. NEITHER PIZZA HUT NOR ANY PERSON OR ENTITY ASSOCIATED WITH PIZZA HUT MAKES ANY WARRANTY OR
        REPRESENTATION WITH RESPECT TO THE SERVICES. WITHOUT LIMITING THE FOREGOING. NEITHER PIZZA HUT NOR ANY PERSON OR
        ENTITY ASSOCIATED WITH PIZZA HUT REPRESENTS OR WARRANTS THAT THE SERVICES, THEIR CONTENT, OR ANY INFORMATION
        OBTAINED THROUGH THE SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS WILL BE
        CORRECTED, THAT THE SERVICES OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
        COMPONENTS, OR THAT THE SERVICES WILL OTHERWISE MEET YOUR REQUIREMENTS, NEEDS OR EXPECTATIONS. UNDER NO
        CIRCUMSTANCES, INCLUDING UNDER ANY THEORY OF LIABILITY (WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE),
        STATUTORY OR OTHERWISE), SHALL PIZZA HUT OR ANY OF PIZZA HUT&apos;S EMPLOYEES, SUBSIDIARIES, AFFILIATES, AGENTS,
        REPRESENTATIVES, DISTRIBUTORS, OR LICENSORS BE LIABLE FOR ANY DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO
        (i) ANY INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES, (ii) DEATH, PERSONAL INJURY, PROPERTY
        DAMAGE, COST OF SUBSTITUTE GOODS OR SERVICES, LOSS OF GOODWILL, BUSINESS INTERRUPTION, COMPUTER FAILURE OR
        MALFUNCTION, LOST DATA ,OR LOST PROFIT AND (iii) ATTORNEYS&apos; FEES THAT RESULT FROM OR ARE OTHERWISE RELATED
        TO THE USE OF OR INABILITY TO USE THE SERVICES. NOR SHALL PIZZA HUT BE RESPONSIBLE FOR ANY DAMAGES WHATSOEVER
        THAT RESULT FROM MISSTATEMENTS, MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF FILES, ERRORS, DEFECTS, VIRUSES.
        DELAYS IN OPERATION OR TRANSMISSION, OR ANY FAILURE OF PERFORMANCE WHETHER OR NOT CAUSED BY EVENTS BEYOND PIZZA
        HUT&apos;S REASONABLE CONTROL, INCLUDING BUT NOT LIMITED TO ACTS OF GOD, COMMUNICATIONS LINE FAILURE, THEFT,
        DESTRUCTION OR UNAUTHORIZED ACCESS TO THIE SERVICES” RECORDS, PROGRAMS OR SERVICES.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        IN NO EVENT SHALL PIZZA HUT&apos;S TOTAL LIABILITY FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION EXCEED US
        $5.00. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL
        DAMAGES; AS A RESULT, THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. TO THE FULLEST EXTENT PERMITTED BY
        APPLICABLE LAW, NOTICE OF ANY CLAIM, ACTION OR PROCEEDING RELATED IN ANY WAY TO THE SERVICES OR THESE TERMS MUST
        BE PROVIDED WITHIN 1 YEAR OF ITS ACCRUAL OR IT IS FOREVER WAIVED AND TIME BARRED.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        PRIVACY POLICY
      </Typography>
      <Typography variant="body1" className={styles.text}>
        By using, communicating through, or submitting information through the Services, you consent to all actions
        taken by us with respect to your information in compliance with the Privacy Policy, which is hereby incorporated
        by reference into these Terms. A copy of our Privacy Policy can be accessed <a href="https://www.pizzahut.com/privacy-policy" target="_blank" rel="noreferrer">here</a> and is expressly incorporated by reference.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        COMMUNICATING WITH PIZZA HUT
      </Typography>
      <Typography variant="body1" className={styles.text}>
        On certain areas of the Services, you may be given the ability to contact us, for example, to sign up for
        services such as e-mail notifications, text messages, and newsletters about our products, to register for a
        particular sweepstakes or contest, or to participate in our interactive forums, like chat rooms and message
        boards. The information that you provide to us through the Services is governed by our Privacy Policy. When you
        voluntarily sign up for these services and communications, you understand and consent to receiving marketing,
        transactional and other messages from Pizza Hut.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        These areas are designed to give our users the ability to contact us with questions or concerns, to engage in
        dialogue with us and other Services users, or to take advantage of other features we may provide from time to
        time. They are not intended for, and should not be used to, submit unsolicited ideas. It is Pizza Hut&apos;s
        company policy not to accept such unsolicited ideas, concepts, techniques, procedures, methods, systems,
        designs, plans, charts or similar materials from outside parties. By entering and using the Services you
        acknowledge and agree that any materials, ideas or other communications you transmit to us in any manner and for
        any reason will not be treated as confidential or proprietary. It is Pizza Hut&apos;s policy not to accept, and
        to return, any unsolicited ideas, concepts, techniques, procedures, methods, systems, designs, plans, charts or
        other similar materials. Nevertheless, should you submit such materials, you understand that you have no
        ownership rights in any ideas you may submit, and you expressly disclaim any rights or causes of action you may
        have with respect to any materials you may submit.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        PIZZA HUT INTELLECTUAL PROPERTY
      </Typography>
      <Typography variant="body1" className={styles.text}>
        The Services and its entire contents, features, and functionality (including but not limited to all information,
        software, Services Updates (as defined herein), text, displays, images, company names, logos, product and
        service names, slogans, video, audio, html code, and the design, selection, and arrangement thereof) (“Pizza Hut
        Content”) are owned and used by Pizza Hut its subsidiaries and affiliates, its licensors, or other providers of
        such material and are protected by United States and international copyright, trademark, patent, trade secret,
        and other intellectual property or proprietary rights laws. These Pizza Hut Content is used to distinguish Pizza
        Hut&apos;s quality products and services.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        These Terms permit you to use the Services for your personal, non-commercial use only. You must not reproduce,
        distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store,
        or transmit any of the Pizza Hut Content. Specifically, you must not:
      </Typography>
      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          Modify copies of any Pizza Hut Content from the Services.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Use any illustrations, photographs, video or audio sequences, or any graphics separately from the accompanying
          text, or outside of the intended Services.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Delete or alter any copyright, trademark, or other proprietary rights notices from copies of materials from
          the Services.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Impersonate or attempt to impersonate Pizza Hut, a Pizza Hut employee, another user, or any other person or
          entity.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Access or use for any commercial purposes any of the Services, including the Pizza Hut Content.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Otherwise sell, license, rent, modify, disassemble, distribute, copy, decompile, reverse engineer, reproduce,
          transmit, publicly display, publicly perform, publish, adapt, edit, attempt to derive the source code, or
          create derivative works from the Pizza Hut Content and other materials on the Services.
        </Typography>
      </ul>

      <Typography variant="body1" className={styles.text}>
        Any attempt to do any of these prohibited activities is a violation of Pizza Hut&apos;s intellectual and
        proprietary rights and the rights of its licensors of the Services and Services Updates.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        If you are a trademark or copyright owner and you believe that your trademark or copyright rights have been
        violated, please go to our
        <a href="/contact-us">Copyright Complaint Process</a>
        page and follow the instructions.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        USER-SUBMITTED CONTENT
      </Typography>
      <Typography variant="body1" className={styles.text}>
        On certain areas of the Services you may be able to submit texts, files, images, photos, videos, sounds, musical
        works, works of authorship, text postings, and other materials and content (&quot;Submitted Content&quot;). You
        have no ownership rights in your account or other access to the Services or features therein, and Pizza Hut may
        delete all Submitted Content at any time, with or without notice, if Pizza Hut deems that you have violated
        these Terms, the law, or for any other reason. Pizza Hut assumes no liability for any information removed from
        the Services, and reserves the right to permanently restrict access to the Services or features therein.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        By posting, displaying, publishing or otherwise submitting Submitted Content on or through the Services, you
        understand and acknowledge that any materials, ideas or other communications you transmit in any manner and for
        any reason will not be treated as confidential or proprietary. Furthermore, you acknowledge and agree that any
        ideas, concepts, techniques, procedures, methods, systems, video, scripts, music, photographs, designs, plans,
        charts or other materials you transmit to Pizza Hut may be used by Pizza Hut anywhere, anytime and for any
        reason whatsoever subject to the following terms:
      </Typography>

      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          You hereby grant to Pizza Hut a limited, nonexclusive, sublicensable, worldwide, fully paid, royalty-free
          license to use, modify, publicly perform, publicly display, reproduce and distribute Submitted Content. This
          license includes the right to host, index, cache, distribute and tag any Submitted Content, as well as the
          right to sublicense Submitted Content to third parties, including other users, for use on other platforms,
          such as for use on mobile phones, in video or music software computer programs.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You represent and warrant that you own the Submitted Content displayed, published or posted by you on the
          Services and otherwise have the right to grant the license set forth herein, and the displaying, publishing or
          posting of your Submitted Content, and our use thereof, does not and will not violate the privacy rights,
          publicity rights, copyrights, trademark rights, contract rights or any other intellectual property rights or
          other rights of any person or entity. You agree to pay for all royalties, fees and any other monies owing any
          person by reason of any Submitted Content displayed, published or posted by you to the Services.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You agree that your Submitted Content is gratuitous and made without restriction, and will not place Pizza Hut
          under any obligation. You agree that Pizza Hut is free to disclose the ideas contained in the Submitted
          Content, including, for example, ingredient or menu item suggestions, on a non-confidential basis to anyone or
          otherwise use the ideas without any additional compensation to you. You acknowledge that, by acceptance of
          your Submitted Content, Pizza Hut does not waive any rights to use similar or related ideas previously known
          to Pizza Hut, or developed by its employees, or obtained from sources other than you.
        </Typography>
      </ul>

      <Typography component="h3" variant="h4" className={styles.title}>
        Your Posting Of Submitted Content Is Further Subject To The Following Posting Rules:
      </Typography>

      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          You agree that no comments submitted or posted by you will violate any right of any third party,
          including copyright, trademark, privacy or other personal or proprietary rights. You further agree that
          no comments submitted or posted by you will be or contain libelous or otherwise unlawful, abusive,
          threatening or obscene material. You are and shall remain solely responsible for the content of any
          comments you make. Harassment in any manner or form is strictly forbidden. Impersonation of others
          is prohibited. You may not upload to, distribute, or otherwise publish through the Services any content
          that is libelous, defamatory, obscene, threatening, invasive of privacy or publicity rights, abusive,
          illegal, or otherwise objectionable that may constitute or encourage a criminal offense, violate the rights
          of any party or which may otherwise give rise to liability or violate any law. You may not upload
          commercial content to the Services or use the Services to solicit others to join or become members of
          any other commercial online service or organization. This provision applies to the fullest extent
          permitted by applicable law. Nothing in this provision is intended to prohibit you from posting bona
          fide reviews, comments, or other content, or otherwise submitting suggestions, ideas, comments or
          questions, related to any products or services offered by Pizza Hut.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You may not post any content that contains personal information about any individual, violates the privacy 
          of any other individual or entity, or anything that you are under a contractual obligation to keep private 
          or confidential. You agree that you will not impersonate any person or organization, including without limitation, 
          the personnel of Pizza Hut. You further agree that you will not misrepresent an affiliation with another person or 
          organization, nor will you post any content that contains slanderous or libelous comments about others, or that 
          infringes any copyright, trademark, patent, trade secret or other intellectual property right of a third party.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You may not post any content that contains business solicitation of any type, including advertising a product or 
          service, offering a product or service for sale, or directing users of the Services to a location for more 
          information about a product or service.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You may not post any software, files or links to other sites, and you may not post any content that contains 
          viruses, corrupted files or any other similar software or programs that may adversely affect the operation of the 
          Services or features of the Services. You may not modify in any way any specifications, technology or application 
          codes provided to you by Pizza Hut or as embedded in the Submitted Content unless expressly authorized in writing 
          by Pizza Hut.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You may not share or transfer password(s) or other access information with any other party, temporarily or 
          permanently. You shall bear sole responsibility for all use of any account you have been permitted to create on the 
          Services and for the confidentiality of your password(s).
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          You understand and acknowledge that messages and postings are the sole responsibility of the author, and that Pizza 
          Hut is not responsible for the message, or information, data, text or other materials in any message that may appear 
          in a chat room, message board, or other interactive feature of the Services. Opinions expressed by users do not 
          necessarily reflect the opinions of Pizza Hut.
        </Typography>
      </ul>

      <Typography variant="body1" className={styles.text}>
        Pizza Hut has no obligation to monitor any materials posted, transmitted or communicated to or within the Services. 
        Pizza Hut, in its sole discretion, has the unexclusive right to: (i) remove or refuse to post any Submitted Content, 
        (ii) disclose your identity or other information about you to any third party who claims that Submitted Content 
        contributed by you violates their rights, including their intellectual property rights or their right to privacy, and 
        (iii) cooperate fully with any law enforcement authorities or court order requesting or directing us to disclose your 
        identity or other information.  If you believe that something on the Services violates these Terms, please
        <a href="/contact-us">Click Here</a> to send us a message through our &quot;Contact Us&quot; page.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        USER ACCOUNT PAYMENT METHODS
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Pizza Hut enables you to make card-based purchases through the Services by linking your user account to a debit,
        credit, and/or prepaid credit card issued in the United States (“Payment Method”). Your user account is not a
        bank account. Pizza Hut is not a bank and does not offer banking or “money transmission services,” and is not a
        “money service business,” as those terms are defined by the U.S. Department of Treasury. By linking a Payment
        Method to your user account, you represent that you are an authorized user of the Payment Method. You may change
        the Payment Method associated with your user account at any time. You are responsible for ensuring that the
        Payment Method associated with your user account is at all times current, non-expired, and valid for payments.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        PAYMENT AUTHORIZATION
      </Typography>
      <Typography variant="body1" className={styles.text}>
        By linking a Payment Method to your user account, you authorize Pizza Hut to charge your linked Payment Method
        as necessary to complete payment to Pizza Hut for the purchase or transaction, including for the total
        transaction amount less any credit redeemed in connection with your purchase. If such charge is rejected or
        fails, Pizza Hut may charge your Payment Method again at a later time without advance notice to you. In the
        event you are entitled to a reversal, refund, chargeback, or other adjustment associated with a purchase you
        made using your user account, you authorize a credit to your Payment Method by Pizza Hut to execute that
        transaction. Your represent and warrant that (i) the Payment Method you supply to us is true, correct and
        complete, (ii) you are duly authorized to use such Payment Method for the purchase, (iii) charges incurred by
        you will be honored by the financial institution supporting the Payment Method, and (iv) you will pay charges
        incurred by you at the posted prices, including delivery and handling charges and all applicable taxes, if any,
        regardless of the amount quoted on the Services at the time of your order. All purchases, orders, and charges
        authorized using the Services subject to the terms and conditions set forth by the entities that issue your
        Payment Method and the Payment Processor. You are responsible for complying with those terms and conditions, and
        you are responsible for payment of all charges and related fees imposed by such entities pursuant to those terms
        and conditions. There is no limit on the frequency of transactions you may make using your user account.
        However, Pizza Hut reserves the right to impose limits without notice on the amount of transaction(s) you make
        at Pizza Hut&apos;s sole discretion, for any reason or no reason.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        PAYMENT PROCESSING
      </Typography>
      <Typography variant="body1" className={styles.text}>
        We use a third-party payment processor (the “Payment Processor”) to process any payments made through the
        Services. The processing of payments will be subject to the terms, conditions, and privacy policies of the
        Payment Processor in addition to these Terms. Pizza Hut is not responsible for these financial transactions, the
        security of your financial information with respect to these transactions, or any errors by the Payment
        Processor. You acknowledge and agree that we are not responsible for any unauthorized charges or other breach of
        your financial information and/or security.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        GENERAL USE AND LICENSE TO USE THE SERVICES
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Pizza Hut hereby grants you a limited, non-exclusive, revocable license to make use of the Services regardless
        of the medium by which the Services are accessed by you (e.g., via a web browser, mobile browser, or mobile
        application), provided that: (i) your use of the Services as permitted is solely for your personal,
        noncommercial use; (ii) you will not copy or distribute any part of the Services in any medium without Pizza
        Hut&apos;s prior written authorization; (iii) you will not alter or modify any part of the Services other than
        as may be reasonably necessary to use the Services for its intended purpose; and (iv) you will otherwise comply
        with the terms and conditions of these Terms.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        You acknowledge that any reliance on the Services, Pizza Hut Content or Submitted Content will be at your own
        risk. Pizza Hut makes no representations regarding the amount of time that the Services, Pizza Hut Content or
        Submitted Content will be preserved. The rights granted herein are non-transferable and are limited to Pizza Hut
        Content and do not include any third-party patents or intellectual property rights. Other than the rights
        granted herein, these Terms do not grant you any rights to use Pizza Hut Content and other intellectual property
        in the design, development, manufacture, licensing, or distribution of third-party devices and accessories for
        use with the Services. These Terms do not entitle you to receive and do not obligate Pizza Hut to provide
        hard-copy documentation, support, telephone assistance, or enhancements or updates to the Services.You
        acknowledge that your use of the Services is at our sole discretion and your license to use the Services may be
        terminated by us at any time, for any reason or for no reason. We reserve the right, in our sole discretion, for
        any reason or no reason with or without notice, to refuse service, to block or prevent future access to and use
        of the Services, to terminate any user&apos;s account, and to alter or delete any material submitted to the
        Services through the user&apos;s account. Following termination of this license, these Terms shall apply to the
        extent practicable. The Services are intended for use by those who are 18 years of age or older only and you
        represent that you are 18 years of age or older and of legal age to enter into a binding agreement. If you are
        not 18 years of age or older, you are prohibited from using the Services without the accompaniment and
        supervision of a parent or legal guardian. If you are a parent or legal guardian, you agree that you have
        provided legal consent and will monitor and supervise the use of the Services by minors under your care, and you
        agree to be responsible for their use of the Services. Any use of the Services by persons under 18 years of age
        and without parental consent will result in immediate termination of their use of the Services.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        You agree not to use or launch any automated system, including without limitation, &quot;robots,&quot;
        &quot;spiders,&quot; &quot;offline readers,&quot; etc., that accesses the Services in a manner that sends more
        request messages to the Pizza Hut servers in a given period of time than a human can reasonably produce in the
        same period by using a conventional online Web browser. Notwithstanding the foregoing, Pizza Hut grants the
        operators of public search engines permission to use spiders to copy materials from the Services for the sole
        purpose of creating publicly available searchable indices of the materials, but not caches or archives of such
        materials. Pizza Hut reserves the right to revoke these exceptions either generally or in specific cases. You
        agree not to collect or harvest any personally identifiable information, including account names, from the
        Services, nor to use the communication systems provided by the Services for any commercial solicitation
        purposes. You agree not to solicit, for commercial purposes, any users of the Services with respect to their
        User Submitted Content.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        USER ACCOUNT
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Before you can make use of certain services associated with the Services, you may be required to register with
        the Services and create an account. You agree and warrant that all information you provide to us through the
        Services, including but not limited to any contact information, registration information, or payment information
        is truthful, accurate, and up-to-date. You further agree to maintain the accuracy of your account information
        and to inform us promptly of any changes to your information, including but not limited to any changes to your
        email address. You are responsible for maintaining the confidentiality of your account and any passwords or
        linked accounts, and you agree to accept responsibility for all activities that occur under your account. You
        acknowledge that your account is personal to you and agree not to provide any other person with access to the
        Services or portions of it using your username, passwords, linked accounts or other security information. You
        agree to immediately notify us of any unauthorized use of your account or any other breach of security you
        become aware of. We are neither responsible for, nor liable, for any loss or other injury that you may incur as
        a result of someone else using your user account, either with or without your knowledge. However, you may be
        liable for the losses of Pizza Hut or others due to such unauthorized use. By creating an account with the
        Services, you consent to receive communications from us electronically via the email address associated with
        your account. Although you can opt-out of receiving promotional communications, we reserve the right to email
        you informational communications about your account or administrative notices regarding the Services, as
        permitted under the Controlling the Assault of Non-Solicited Pornography and Marketing (“CAN-SPAM”) Act. You are
        expressly prohibited from selling, trading, or transferring your account (including but not limited to, selling,
        trading, or transferring emails associated with such account). You may never use another&apos;s account without
        permission. If you have created a Loyalty Program account, our
        <a href="https://hutrewards.pizzahut.com/terms">Hut Rewards Loyalty Program Terms and Conditions</a> , which are
        hereby incorporated by reference, will apply to that account in addition to these Terms.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        YOUR ORDER
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Pizza Hut enables users to transact with Pizza Hut to initiate online purchases from participating restaurants.
        When you place an order through the Services, you are ordering directly from a participating restaurant and the
        contract for supplying the products will be between you and the restaurant that accepts your order. The
        restaurant where you collect your products is responsible for preparing the products and providing them to you.
        You further understand and agree that you may be purchasing directly from franchise restaurants (and not Pizza
        Hut) and that Pizza Hut has no responsibility arising out of or related to any products that you purchase from
        franchise restaurants through the Services.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        You agree that your order is an offer to buy, under these Terms, all products and services listed in your order.
        All orders must be accepted by the restaurant that you selected, or there will be no obligation to sell the
        products or services to you. Pizza Hut and/or an independently franchised restaurant location may choose not to
        accept orders through the Services, in its sole discretion, even after we send you a confirmation email with
        your order number and details of the items you have ordered.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        When you purchase products or services through the Services, prices will be made clear during the order process.
        The price charged for a product or service will be the price in effect at the time the order is placed and will
        be set out in your order confirmation email or in-Services notification. Price increases will only apply to
        orders placed after such changes. Posted prices do not include taxes or charges for delivery and handling. All
        such taxes and charges will be added to your order total and will be itemized in your shopping cart and in your
        order confirmation email or in-Services notification. Pizza Hut may charge you a convenience or service fee in
        addition to the amounts charged in connection with a transaction utilizing the Services. This service fee will
        be displayed in the Services and in your email receipt as a “Service Fee.”
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Prices posted on this Services may be different than prices offered at each Pizza Hut franchise location. All
        prices, discounts, and promotions posted on this Services are subject to change without notice. Pizza Hut does
        not warrant the completeness or accuracy of any information, including menu information, product descriptions,
        ingredient lists, calorie count, or business operation information. The inclusion of any product or service on
        the Services does not imply or warrant that these products or services will be available at the restaurant where
        you collect your order. Pizza Hut strives to display accurate price information, however, it may, on occasion,
        make inadvertent typographical errors, inaccuracies or omissions related to pricing and availability. In
        addition, we may offer, from time to time, promotions through the Services that may affect pricing and that are
        governed by terms and conditions separate from these Terms. If there is a conflict between the terms for a
        promotion and these Terms, the promotion terms will govern.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Pizza Hut reserves the right to correct any errors, inaccuracies, or omissions at any time and to cancel any
        orders arising from such occurrences. Pizza Hut reserves the right, with or without notice, to do any one or
        more of the following for any reason: (i) limit the available quantity of or discontinue any product or service,
        (ii) impose conditions on the honoring of any coupon, coupon code, promotional code, or other similar promotion,
        (iii) bar you from making or completing any or all transactions, and (iv) refuse to provide you with any product
        or service. You are solely responsible for any taxes applicable to your transaction. You acknowledge and agree
        that the ability to purchase products and services through the Services is only available at participating
        locations (which locations are subject to change without notice). Prices and availability of menu items and
        customization options vary by location.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        You agree to be charged at the time you place your order for product or services, and that the transaction for
        the purchase of products or services is final and complete at the time you are charged.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        DELIVERY VIA APP OR WEB
      </Typography>
      <Typography variant="body1" className={styles.text}>
        In some locations, you may be able to place an order for delivery. Pizza Hut and its delivery vendor(s) reserve
        the right to accept or decline an order for any reason up until the time the product is delivered to you. You
        acknowledge and agree that delivery times may vary, and that Pizza Hut makes no warranty or guarantee with
        respect to when your order will be delivered. Delivery is not available in all locations. You agree that your
        delivery request (where available) may be fulfilled by a third party in Pizza Hut&apos;s discretion. Prices
        posted by third-party delivery sites may be different from prices offered at each Pizza Hut franchise location.
        Pizza Hut does not warrant the completeness or accuracy of any information provided by third-party delivery
        sites. You further agree that Pizza Hut may provide your contact information, including telephone number, to its
        delivery vendor(s) so that you may receive information regarding your order.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        RETURNS AND REFUNDS
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Pizza Hut will not accept returns of products or services purchased through the Services. You may be entitled to
        a refund, at the sole discretion of Pizza Hut or its agents, based on the individual circumstances underlying
        each request. All refunds will be processed via the Payment Method used to place the order. Please allow at
        least four weeks for the refund to be processed. Refund times may vary based on the terms and conditions of the
        issuer of your Payment Method. If your order is not accurate or complete when you pick it up, please immediately
        inform the restaurant.
      </Typography>
    </Box>
    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        PROHIBITED TRANSACTIONS
      </Typography>
      <Typography variant="body1" className={styles.text}>
        The Services may only be used for the bona fide purchase of goods and/or services offered in the ordinary course
        of Pizza Hut&apos;s business, and may not be used to process a payment or otherwise transfer money between two
        parties. The Services may not be used for transactions in which you request cash back from Pizza Hut. The
        Services shall not be used for the purpose of accepting or transferring security or payment for loans, providing
        cash advances, check cashing, or otherwise distributing cash to any person or entity, or in connection with any
        lottery or gambling activity. Pizza Hut reserves the right to decline any attempted transaction if it appears
        that any of these Terms have been violated.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        SERVICES UPDATE
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Pizza Hut may make available for download certain updates or upgrades for the Services to update, enhance, or
        further develop the Services (“Services Updates”). Pizza Hut may, at its discretion, automatically upload
        Services Updates to your device. You agree to accept these Services Updates, and to pay for any costs associated
        with receiving them. The license granted herein allows you to download and use the Services Updates to update
        the Services on any device that you own or control. These Terms do not allow you to update devices that you do
        not own or control, and you may not make the Services Updates available over a network where it could be used by
        multiple devices or multiple computers at the same time. You may not make any copies of the Services Updates,
        unless such copy is authorized in writing by Pizza Hut.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        APPLE APPLICATIONS
      </Typography>
      <Typography variant="body1" className={styles.text}>
        If you download and/or use the Services through an iPhone or iPad application, you acknowledge that these Terms
        are entered into by and between Pizza Hut and you, and not Apple, Inc. (“Apple”). You acknowledge that Apple has
        no obligation to maintain or support the Services. These Terms incorporate and supplement the Apple terms and
        conditions located on The App Store, including the Licensed Application End User terms therein (“Apple Terms”).
        If you are using the Services through an Apple application, you also acknowledge and agree: (i) Apple has no
        obligation to provide support or maintenance services in relation to the Apple application, (ii) any claims
        relating to the possession or use of the Apple application are between you and Pizza Hut, and (iii) Apple will
        not be responsible or liable to you for any claim by a third party that your possession or use of the Apple
        application infringes any intellectual property rights. Apple does not give or enter into any warranty,
        condition or other term in relation to the Apple Application and will not be liable to you for any claims,
        losses, costs or expenses of whatever nature in relation to the Apple application.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        INDEMNIFICATION
      </Typography>
      <Typography variant="body1" className={styles.text}>
        You agree to defend, indemnify and hold harmless Pizza Hut, its parents, affiliates, subsidiaries, officers,
        employees, and Services contractors and each of their officers, employees and agents from any actual or alleged
        claims, demands, causes of action, liabilities, damages, judgments, awards, losses, costs, expenses, or fees
        (including reasonable attorney&apos;s fees) arising out of or relating to: (i) your violation of these Terms,
        (ii) your violation of any local, state, federal, or international law, rule, or regulation, (iii) a claim by a
        third party that is based on your use of the Services, your Submitted Content, or participation in the Services,
        (iv) information or material posted or transmitted through your device, computer, or account, even if not
        submitted by you, (v) any misrepresentation made by you, (vi) any dispute between you and another user of the
        Services or participant in the Services relating to the Services in any way, (vii) the theft, misappropriation,
        or disclosure of your passwords or other account details (including linked accounts), (viii) your authorization
        of anyone else to use your account, passwords, linked accounts and/or (ix) your use of any of the products or
        services provided through the Services which may result in, without limitation, injury to or death of any person
        or damage to any property. You will cooperate as fully and as reasonably required in Pizza Hut&apos;s defense of
        any claim. Pizza Hut reserves the right, at its own expense, to assume the exclusive defense and control of any
        matter otherwise subject to indemnification by you, and you shall not, in any event, settle any matter without
        the written consent of Pizza Hut.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        HYPERLINKS
      </Typography>
      <Typography variant="body1" className={styles.text}>
        The Services may link to sites not maintained by or related to Pizza Hut. Hyper links are provided as a service
        to users and are not sponsored by or affiliated with the Services or Pizza Hut. Pizza Hut has not reviewed the
        sites hyperlinked to or from the Services and is not responsible for the content of any other site. These links
        are to be accessed at the user&apos;s own risk. Pizza Hut makes no representations or warranties about the
        content, completeness or accuracy of these links or the sites or services hyperlinked to or from the Services.
        Furthermore, Pizza Hut does not implicitly endorse third-party sites hyperlinked to or from the Services.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        MOBILE SERVICES
      </Typography>
      <Typography variant="body1" className={styles.text}>
        If you choose to participate in the Services on a mobile device, you are solely responsible for obtaining and
        paying for any such mobile device, and all related fees and services, including data and internet usage fees.
        You may choose to participate in Pizza Hut promotions or services that may involve the use of text messaging
        (either sending or receiving). If you chose to subscribe to text messaging from Pizza Hut, you consent to
        receive text marketing messages at the mobile number you provided, including messages sent using automated
        technology from or on behalf of Pizza Hut, and understand that such consent is not a condition of purchasing any
        goods or services. Pizza Hut will not charge you for the text messaging; however, standard text messaging rates
        will apply to each text message sent or received as provided in your wireless rate plan (contact your carrier
        for pricing plans and details). You understand and agree that we, our vendors, and the carriers are not liable
        for any delay or undelivered messages. Message and data rates may apply depending on your service; contact your carrier with any questions.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Many of our restaurants are owned and operated by franchisees. These Terms do not apply to any separate text
        message marketing programs offered by those franchisees. If you are receiving text messages from a Pizza Hut
        franchisee and wish to opt-out, you must do so directly through the respective franchisee. To stop receiving
        automated promotional text messages from Pizza Hut text “STOP” to 31524. For more information, text HELP to
        31524.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Your voluntary provision of your cell phone number to Pizza Hut constitutes your consent that we, or someone
        acting on our behalf, may contact you by phone or text message at that phone number, and your consent to receive
        such communications for transactional, operational, or informational purposes. When you provide your phone
        number to us, you warrant that you are the current subscriber or authorized user of that phone number. You
        understand and agree that calls and/or messages may be sent using automated technology, including but not
        limited to an automatic telephone dialing system or artificial or prerecorded voice. You understand and agree
        that you may not revoke your consent to be contacted in this manner. You agree to immediately contact us if any
        number you have provided to Pizza Hut is no longer associated with you. Your failure to provide and update your
        accurate information is a breach of these Terms. You agree that we and our agents may monitor and record any
        telephone calls or other communications between us and/or our agents and you and/or your agents. You understand
        and agree that text messages may be sent to you at any time of day to the fullest extent permitted by applicable law.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        LIVE CHAT
      </Typography>
      <Typography variant="body1" className={styles.text}>
        If you choose to use or attempt to use our Live Chat feature, you agree that you will only use or attempt to use
        it in compliance with these Terms and in accordance with our Privacy Policy, which is expressly incorporated by
        reference.  You must not use or attempt to use this feature to:
      </Typography>
      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          Corrupt, damage, or interfere with the Live Chat feature or any data, software, hardware, website or information
          technology systems related to us or any third party;
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Send any offensive, inflammatory, defamatory, fraudulent, or otherwise unlawful content;
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Infringe on any intellectual property or other rights;
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Adversely affect our reputation or public image or that of any third party; and
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Cause annoyance or inconvenience to us or any third party.
        </Typography>
      </ul>
      <Typography variant="body1" className={styles.text}>
        You understand and agree that we may terminate your use of the Live Chat feature for any reason in our sole discretion.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        During your use or attempted use of the Live Chat feature, you may provide personal data including your:
      </Typography>
      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          Email address;
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Address;
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Telephone number; and
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Other personal data for the purpose of contacting you or for other reasons.
        </Typography>
      </ul>
      <Typography variant="body1" className={styles.text}>
        In providing us with this data, you understand and agree that your data will be collected, used, disclosed or
        otherwise processed in accordance with our Privacy Policy, which is expressly incorporated by reference.  If you
        are submitting information relating to other individuals, you must ensure that you have their express consent and
        that they are aware of how their personal data will be handled as described above.  At no point should you provide
        any banking, financial, or payment card information via the Live Chat feature.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        We do not guarantee that you will have continuous access to the Live Chat feature or that it will be supplied
        fault free. We will not be liable in the event that the Live Chat feature is unavailable to you for any reason
        including upgrades, preventative or remedial maintenance activities, and we may suspend or terminate the availability
        of this feature at any time for no reason.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        By using the Live Chat feature, you understand and agree that some portions of the feature might be automated
        and that your chat session may be stored or retained for customer service or monitoring purposes.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        DISPUTE RESOLUTION/INCLUDING ARBITRATION AGREEMENT CLASS ACTION WAIVER; JURY TRIAL WAIVER
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Please read this Dispute Resolution section carefully. It affects your legal rights. It provides for the resolution
        of most claims and disagreements between you and Pizza Hut through individual arbitration instead of court
        trials and class actions. Arbitration is more informal than a lawsuit in court, uses a neutral arbitrator
        instead of a judge or jury, and discovery is more limited. Arbitration is final and binding and subject to only
        very limited review by a court. This section also contains a jury trial waiver and a waiver of any and all
        rights to proceed in a class, collective, consolidated, private attorney general or representative action in
        arbitration, or litigation to the fullest extent permitted by applicable law.
      </Typography>

      <Typography component="h3" variant="h4">
        (a) Mandatory Informal Dispute Resolution Process
      </Typography>
      <ul>
        <Typography variant="body1" className={styles.text}>
          There might be an occasion in which a Dispute (as defined below) arises between you and Pizza Hut. Should such
          a situation arise, Pizza Hut is committed to working with you to resolve the Dispute. Therefore, for any
          Dispute that arises between you and Pizza Hut, both parties agree that they will first make a good faith
          effort to resolve it informally before initiating any formal dispute resolution proceeding as set forth below.
        </Typography>
        <Typography variant="body1" className={styles.text}>
          The informal Dispute resolution process requires that the party raising the Dispute send a personally signed,
          written notice to the other party, providing all of the following information: (i) name and contact
          information (address, telephone number, and email address); (ii) sufficient information to enable you or Pizza
          Hut to identify any account and transaction at issue; and (iii) a detailed description of (a) the nature and
          basis of the Dispute and any claims, and (b) the nature and basis of the relief sought, with a detailed
          calculation for it. You agree to send the foregoing notice to the following email address: phlegal@yum.com or
          via certified mail to: Pizza Hut Legal Department, 7100 Corporate Drive, Plano, Texas 75024. Our notice to you
          will be sent to you based on the most recent contact information that you have provided to us. The time period
          referenced below begins to run upon receipt of a completed written notice.
        </Typography>

        <Typography variant="body1" className={styles.text}>
          You and Pizza Hut then agree to negotiate in good faith about the Dispute, including through an informal and
          individualized telephonic settlement conference between you and Pizza Hut if the party receiving the notice
          requests such a conference. If either party to the Dispute is represented by counsel, that party&apos;s
          counsel may participate in this conference, but the party also must personally attend the conference. This
          process should lead to resolution of the Dispute, but if it is not resolved within 60 days after receipt of
          the completed notice detailed above (which period can be extended by agreement of the parties), you and Pizza
          Hut agree to the further Dispute resolution provisions below.
        </Typography>
        <Typography variant="body1" className={styles.text}>
          This informal Dispute resolution process is a condition precedent and prerequisite to commencing arbitration
          or a proceeding in small claims court. The party initiating arbitration must include with a demand for
          arbitration a personally signed certification of compliance with the informal Dispute resolution process (if
          you initiate arbitration, then the certification must be signed by you and by your counsel, if you are
          represented; if we initiate arbitration, then the certification must be signed by a Pizza Hut representative
          and our counsel, if we are represented.)
        </Typography>
        <Typography variant="body1" className={styles.text}>
          The parties agree that any relevant limitations period (including applicable statutes of limitations) and
          filing fee or other deadlines shall be tolled while the parties engage in this informal Dispute resolution
          process. If the sufficiency of a notice or compliance with this informal Dispute resolution process is at
          issue, it may be decided by a court of competent jurisdiction at either party&apos;s election, and any formal
          dispute resolution proceeding shall be stayed pending resolution of the issue. A court of competent
          jurisdiction shall have the authority to enforce this condition precedent to arbitration, which includes the
          power to enjoin the filing or prosecution of a demand for arbitration. Notwithstanding the foregoing, either
          party retains the right to seek appropriate relief for non-compliance in arbitration.
        </Typography>
      </ul>

      <Typography component="h3" variant="h4">
        (b) Arbitration Agreement
      </Typography>

      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          Arbitration. Any Dispute between you and Pizza Hut that cannot be resolved informally as detailed above shall
          be resolved through individual arbitration. BY AGREEING TO ARBITRATE, EACH PARTY IS GIVING UP ITS RIGHT TO GO
          TO COURT AND HAVE ANY DISPUTE HEARD BY A JUDGE OR JURY TO THE FULLEST EXTENT PERMITTED BY LAW.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          Notwithstanding the foregoing, either you or Pizza Hut may elect to have a Dispute heard in small claims court
          on an individual basis if the Dispute qualifies for small claims court and as long as the matter remains in
          such court and is not removed or appealed to a court of general jurisdiction. Whether a Dispute falls within
          the jurisdictional limits of small claims court is for the small claims court to decide in the first instance
          and for a court of competent jurisdiction to otherwise decide.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          “Dispute” shall be interpreted broadly and include, but not be limited to any dispute or claim arising out of
          or relating to these Terms, your access to or participation in the Loyalty Program, or your relationship with
          Pizza Hut, whether based in contract, tort, statute, fraud, misrepresentation, or any other legal theory.
          Dispute shall include, but not be limited to, (i) any dispute or claim that arose before the existence of
          these or any prior Terms (including, but not limited to, claims relating to advertising); (ii) any dispute or
          claim that is currently the subject of purported class action litigation in which you are not a member of a
          certified class; and (iii) any dispute or claim that may arise after termination of these Terms. Dispute,
          however, does not include disagreements or claims concerning patents, copyrights, trademarks, and trade
          secrets and claims of piracy or unauthorized use of intellectual property. The arbitrator shall decide all
          issues except the following (which are for a court of competent jurisdiction to decide): (i) issues that are
          specifically reserved for a court in these Terms; (ii) issues that relate to the scope, validity, and
          enforceability of the arbitration agreement, class action waiver, or any of the provisions of this Dispute
          Resolution section; and (iii) issues that relate to the arbitrability of any Dispute.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          These Terms constitute a transaction in interstate commerce and this arbitration provision shall be governed
          by the Federal Arbitration Act and federal arbitration law (not state arbitration law). The arbitration shall
          be administered by the American Arbitration Association (“AAA”) in accordance with the then-current Consumer
          Arbitration Rules of the American Arbitration Association (“AAA”) pursuant to its AAA Rules as modified by
          this arbitration agreement. You can obtain the AAA Rules from the AAA by visiting its website
          (https://adr.org/). If there is a conflict between this arbitration agreement and the AAA Rules, this
          arbitration agreement shall govern. You and we understand that the AAA made an administrative determination
          that this arbitration provision comports with the Consumer Due Process Protocols. That determination is final
          and you and we agree that neither a court nor an arbitrator shall have the authority to revisit it.
        </Typography>

        <Typography component="li" variant="body1" className={styles.text}>
          If the AAA is unable or unwilling to administer a proceeding consistent with this arbitration agreement as
          written, the parties shall agree on a substitute arbitration organization that will do so. If the parties
          cannot agree, the parties shall mutually petition a court of competent jurisdiction to appoint an arbitration
          organization that will administer the arbitration consistent with this arbitration agreement.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          To begin an arbitration proceeding, after satisfying the informal process identified in the Mandatory Informal
          Dispute Resolution Process section above, you or we must (i) send a personally signed (by the initiating party
          and your or our counsel, if represented) demand for arbitration that complies with the AAA Rules and describes
          in detail (a) the nature and basis of the claims, and (b) the nature and basis of the relief sought, including
          a detailed calculation for it; (ii) send the personally signed certification of completion described in the
          Mandatory Informal Dispute Resolution Process section; and (iii) contact the AAA and follow the appropriate
          procedures to commence the arbitration. By signing the arbitration demand, counsel certifies to the best of
          their information, knowledge, and belief, formed after a reasonable inquiry that: (i) the arbitration demand
          is not being presented for any improper purpose, such as to harass, cause unnecessary delay, or needlessly
          increase the cost of dispute resolution; (ii) the claims or other legal contentions are warranted by existing
          law or by a nonfrivolous argument for extending, modifying, or reversing existing law or for establishing new
          law; and (iii) the factual contentions have evidentiary support or, if specifically so identified, will likely
          have evidentiary support after reasonable opportunity for further investigation or discovery. The arbitrator
          shall be authorized to impose any sanctions available under Federal Rule of Civil Procedure 11 on represented
          parties and their counsel. Your demand for arbitration must be sent to Pizza Hut Legal Department, 7100
          Corporate Drive, Plano, Texas 75024. Our demand for arbitration to you will be sent to you based on the most
          recent contact information that you have provided to us.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          You may choose to have the arbitration conducted by phone, video, in-person or through written submissions,
          except any Dispute over $25,000 shall have an in-person or video hearing. You and Pizza Hut reserve the right
          to request a hearing in any matter from the arbitrator. If you initiate arbitration, then you agree to
          personally appear at any in-person, video, or telephonic hearing (along with your counsel, if you are
          represented). If we initiate arbitration, then Pizza Hut agrees to have a representative appear at any
          in-person, video, or telephonic hearing (along with our counsel, if we are represented). If an in-person
          arbitration hearing is required, then it will be conducted at a location that is reasonably convenient to you
          or at another mutually agreed location. The arbitrator shall be located in reasonable proximity to you or the
          mutually agreed location if a hearing is required or requested consistent with the above.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          A single arbitrator will resolve the Dispute consistent with these Terms and according to applicable law and
          facts based upon the record and no other basis. The arbitrator will honor claims of privilege recognized by
          law and will take reasonable steps to protect confidential or proprietary information. An arbitrator may award
          on an individual basis any relief that would be available in a court, including injunctive or declaratory
          relief only in favor of the individual party seeking relief and only to the extent necessary to provide relief
          warranted by that party&apos;s individual claim. To the fullest extent permitted by applicable law, you and we
          agree that each may bring claims against the other only in your or our individual capacity and not as a
          plaintiff or class member in any purported class, collective, consolidated, private attorney general, or
          representative proceeding. Further, unless both you and we agree otherwise, an arbitrator may not consolidate
          more than one person&apos;s claims and may not otherwise preside over any form of class, collective,
          consolidated, private attorney general, or representative proceeding. If, after exhaustion of all appeals, any
          of these prohibitions on non- individualized injunctive or declaratory relief and class, collective,
          consolidated, private attorney general, or representative proceedings are found to be unenforceable with
          respect to a particular claim or request for relief (such as a request for public injunctive relief), then
          such a claim or request for relief will be decided by a court of competent jurisdiction, after all other
          claims and requests for relief are arbitrated. An arbitrator must follow and enforce these Terms of Use as a
          court would. The arbitrator shall issue a reasoned written decision that explains the arbitrator&apos;s
          essential findings and conclusions. The arbitrator&apos;s award may be entered in any court having
          jurisdiction over the parties only if necessary for purposes of enforcing the arbitrator&apos;s award. An
          arbitrator&apos;s award that has been fully satisfied shall not be entered in any court. The arbitration award
          shall be binding only among the parties to the arbitration and shall have no preclusive effect in any other
          arbitration or other proceeding involving a different party.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Payment of filing and other fees shall be governed by the AAA Rules unless they are authorized by law or the
          arbitrator determines that a claim or proceeding was frivolous or brought for an improper purpose or in bad
          faith (as measured by the standards set forth in Federal Rule of Civil Procedure 11(b)); but if applicable
          arbitration rules or laws require Pizza Hut to pay a greater portion or all of such fees and costs in order
          for this arbitration provision to be enforceable, then Pizza Hut will have the right to elect to pay the fees
          and costs and proceed to arbitration. In addition, the provisions of Federal Rule of Civil Procedure 68
          (cost-shifting) shall apply and be enforced by the arbitrator after entry of an award.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Additional Procedures for Mass Arbitrations. You and Pizza Hut agree that the following additional procedures
          shall apply to Mass Arbitrations (as defined below). If 25 or more similar Disputes (including yours) are
          asserted against Pizza Hut by the same or coordinated counsel or are otherwise coordinated (“Mass
          Arbitrations”), you understand and agree that these additional procedures apply and that the resolution of
          your Dispute might be delayed or that it might ultimately proceed in court. If your Dispute is part of a Mass
          Arbitration, any applicable limitations periods (including statutes of limitations) shall be tolled for your
          Dispute from the time that your Dispute is first submitted to the AAA until your Dispute is selected to
          proceed as part of a staged process or is settled, withdrawn, otherwise resolved, or opted out of arbitration
          pursuant to this provision.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          STAGE ONE: Counsel for the claimants and counsel for Pizza Hut shall each select up to 50 claims (per side)
          (100 claims total) to proceed first in individual arbitration proceedings as part of a staged process. Each of
          these cases shall be assigned to a different arbitrator and proceed individually. The number of Disputes to be
          selected in Stage One can be increased by agreement of counsel for the parties (and if there are fewer than
          100 Disputes, all shall proceed individually in Stage One). If a case is withdrawn before the issuance of an
          arbitration award, another claim shall be selected to proceed as part of Stage One. The remaining Disputes
          shall not be filed or deemed filed in arbitration nor shall any arbitration fees be assessed in connection
          with those Disputes until they are selected to proceed to individual arbitration proceedings as part of a
          staged process. After this initial set of proceedings, if counsel for the parties are unable to resolve the
          remaining Disputes at this time, counsel for the parties shall participate in a global mediation session with
          a retired federal or state court judge jointly selected Stage One, and Pizza Hut shall pay the mediator&apos;s
          fee.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          STAGE TWO: If the parties are still unable to resolve the remaining Disputes at the conclusion of the
          mediation following Stage One, each side shall select 100 claims (per side) (200 claims total) to proceed as
          cases in individual arbitration proceedings as part of a second staged process. No more than 5 cases may be
          assigned to a single arbitrator to proceed individually. The number of Disputes to be selected in Stage Two
          can be increased by agreement of counsel for the parties (and if there are fewer than 200 Disputes, all shall
          proceed individually in Stage Two). If a case is withdrawn before the issuance of an arbitration award,
          another claim shall be selected to proceed as part of Stage Two. The remaining Disputes shall not be filed or
          deemed filed in arbitration nor shall any arbitration fees be assessed in connection with those Disputes.
          After this second set of staged proceedings, counsel for the parties shall engage in a second global mediation
          session of all remaining Disputes with a retired federal or state court judge jointly selected by counsel in
          an effort to resolve the remaining Disputes (as informed by the adjudications of cases in Stages One and Two),
          and Pizza Hut shall pay the mediator&apos;s fee.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Upon the completion of the mediation set forth in Stage Two, each remaining Dispute (if any) that is not
          settled or not withdrawn shall be opted out of arbitration and may proceed in a court of competent
          jurisdiction consistent with the remainder of the Terms, including the other provisions of this Dispute
          Resolution section. Notwithstanding the foregoing, counsel for the parties may mutually agree in writing to
          proceed with the adjudication of some or all of the remaining Disputes in individual arbitrations consistent
          with the process set forth in Stage Two (except Disputes shall be randomly selected and mediation shall be
          elective by agreement of counsel) or through another mutually-agreeable process. A court of competent
          jurisdiction shall have the authority to enforce the Additional Procedures for Mass Arbitrations, including
          the power to enjoin the filing or prosecution of arbitrations and the assessment or collection of arbitration
          fees.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          The Additional Procedures for Mass Arbitrations provision and each of its requirements are essential parts of
          this arbitration agreement. If, after exhaustion of all appeals, a court of competent jurisdiction decides
          that the Additional Procedures for Mass Arbitrations apply to your Dispute and are not enforceable, then your
          Dispute shall not proceed in arbitration and shall only proceed in a court of competent jurisdiction
          consistent with the remainder of the Terms, including the other provisions of this Dispute Resolution section.
        </Typography>
        <Typography component="li" variant="body1" className={styles.text}>
          Future Changes to the Binding Arbitration Agreement. If we make any future changes to the arbitration
          agreement (other than a change to our contact information), you may reject any such change by sending your
          personally signed, written notice via certified mail to:
        </Typography>
      </ul>

      <Typography component="address" variant="body1" className={styles.text}>
        Pizza Hut Legal Department
        <br />
        7100 Corporate Drive
        <br />
        Plano, Texas 75024
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Such written notice does not constitute an opt out of arbitration altogether. By rejecting any future change,
        you are agreeing that you will arbitrate any Dispute between you and Pizza Hut in accordance with this version
        of the arbitration agreement.
      </Typography>

      <Typography component="h3" variant="h4" className={styles.title}>
        (c) Class Action Waiver
      </Typography>

      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          You and Pizza Hut each agree that any proceeding, whether in arbitration or in court, will be conducted only
          on an individual basis and not in a class, collective, consolidated, private attorney in such an action in
          arbitration or in court to the fullest extent permitted by applicable law. Notwithstanding the foregoing, the
          parties retain the right to participate in a class-wide settlement.
        </Typography>
      </ul>

      <Typography component="h3" variant="h4">
        Jury Trial Waiver
      </Typography>
      <ul>
        <Typography component="li" variant="body1" className={styles.text}>
          You and Pizza Hut waive any right to a jury trial to the fullest extent permitted by applicable law.
        </Typography>
      </ul>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        APPLICABLE LAW AND VENUE
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Except with respect to the application of the Federal Arbitration Act and federal arbitration law as set forth
        above, these Terms and your access to or participation in the Services are governed by the laws of the state of
        Texas without regard to Texas conflict of laws rules. If the arbitration agreement is ever deemed unenforceable
        or void, or a dispute between the parties is not subject to arbitration and cannot be brought in small claims
        court, you irrevocably consent to the exclusive jurisdiction of the federal and state courts in the Northern
        District of Texas for purposes of any legal action arising out of or related to access to or participation in
        the Services or these Terms (including for any challenge to the enforceability of any of the provisions of the
        Terms) and waive any objections as to personal jurisdiction or as to the laying of venue in such courts due to:
        (i) inconvenient forum or (ii) any other basis or any right to seek to transfer or change venue of any such
        action to another court.
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        NOTICES
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Where required, Pizza Hut may give notice to you by a general posting in the Services, by electronic mail, or by
        conventional mail to your address of record. You may give notice to PIZZA HUT by electronic mail or by
        conventional mail to the address below. If you have any questions about these Terms, the practices of the
        Services, or your dealings with Pizza Hut, please contact us by using this Form or at the following address:
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Pizza Hut, LLC
      </Typography>
      <Typography variant="body1" className={styles.text}>
        7100 Corporate Drive
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Plano, Texas 75024
      </Typography>
    </Box>

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        MISCELLANEOUS
      </Typography>
      <Typography variant="body1" className={styles.text}>
        Both you and Pizza Hut acknowledge and agree that no partnership is formed, and neither you nor Pizza Hut have
        the power or the authority to obligate or bind the other.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        The failure of Pizza Hut to exercise or enforce any right or provision of these Terms shall not constitute a
        waiver of such right or provision. If any provision of these Terms is found by a court of competent jurisdiction
        to be invalid or unenforceable, the parties nevertheless agree that the court should endeavor to give effect to
        the parties&apos; original intentions as reflected in the provision, and the other provisions of these Terms
        shall remain in full force and effect except as otherwise provided herein.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        The Dispute Resolution (Including Arbitration Agreement; Class Action Waiver; Jury Trial Waiver) and limitations
        on Pizza Hut&apos;s liability shall survive termination of these Terms.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Software that may be available in connection with the Services is subject to United States export controls. No
        software may be downloaded from the Services or otherwise exported or re-exported in violation of U.S. export
        laws. Downloading or using the software is at your sole risk.
      </Typography>
      <Typography variant="body1" className={styles.text}>
        The failure of Pizza Hut to comply with these Terms because of an act of God, war, fire, riot, terrorism,
        pandemic or epidemic, earthquake, actions of federal, state or local governmental authorities or for any other
        reason beyond the reasonable control of Pizza Hut, shall not be deemed a breach of these Terms. If Pizza Hut
        fails to act with respect to your breach or anyone else&apos;s breach on any occasion, Pizza Hut is not waiving
        its right to act with respect to future or similar breaches.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        The headings in these Terms are for your convenience and reference. These headings do not limit or affect these
        Terms.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        If any provision of these Terms of use shall be unlawful, void or for any reason unenforceable, then that
        provision shall be deemed severable from these Terms of use and shall not affect the validity and enforceability
        of any remaining provisions except as provided herein.
      </Typography>

      <Typography variant="body1" className={styles.text}>
        Pizza Hut may assign these Terms, in whole or in part, at any time with or without notice to you. You may not
        assign these Terms, or any part of it, to any other person. Any attempt by you to do so is void. You may not
        transfer to anyone else, either temporarily or permanently, any rights to use all or any part of the Services.
      </Typography>
    </Box>

    <hr style={{ border: '0', borderTop: '1px solid #cfcecc', marginBottom: '3rem' }} />

    <Box component="section" className={styles.section}>
      <Typography variant="h2" className={styles.title}>
        Still Have Questions?
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href="/contact-us"
        style={{ paddingLeft: '5rem', paddingRight: '5rem' }}
      >
        Contact Us
      </Button>
    </Box>
  </>
);

export default TermsOfUse;
